/**
 * Utils Command Group
 * Developer utilities for common tasks
 */
import { Command } from 'commander';
import chalk from 'chalk';
import { createPasswordCommand } from './password.js';
import { createUuidCommand } from './uuid.js';
import { createHashCommand } from './hash.js';
import { createBase64EncodeCommand } from './base64-encode.js';
import { createBase64DecodeCommand } from './base64-decode.js';
import { createHttpCommand } from './http.js';
import { createJwtCommand } from './jwt.js';
import { createUnixTimeCommand } from './unix-time.js';
import { createTimezoneCommand } from './timezone.js';
import { createUrlEncodeCommand } from './url-encode.js';
import { createUrlDecodeCommand } from './url-decode.js';
import { createCronCommand } from './cron.js';
import { createMarkdownPreviewCommand } from './markdown-preview.js';
import { runInteractiveMode } from './interactive.js';

function showUtilsHelp(): void {
    console.log(chalk.bold.cyan('🛠️  jai1 utils') + chalk.dim(' - Developer utilities'));
    console.log();
    console.log(chalk.bold('Mã hóa & Bảo mật:'));
    console.log(`  ${chalk.cyan('password')}         Tạo mật khẩu ngẫu nhiên`);
    console.log(`  ${chalk.cyan('uuid')}             Tạo UUID v4`);
    console.log(`  ${chalk.cyan('hash')}             Hash text (MD5/SHA/bcrypt)`);
    console.log(`  ${chalk.cyan('jwt')}              Decode/encode JWT tokens`);
    console.log();
    console.log(chalk.bold('Encoding:'));
    console.log(`  ${chalk.cyan('base64-encode')}    Encode sang Base64`);
    console.log(`  ${chalk.cyan('base64-decode')}    Decode từ Base64`);
    console.log(`  ${chalk.cyan('url-encode')}       Encode URL components`);
    console.log(`  ${chalk.cyan('url-decode')}       Decode URL components`);
    console.log();
    console.log(chalk.bold('Thời gian:'));
    console.log(`  ${chalk.cyan('unix-time')}        Chuyển đổi unix timestamp`);
    console.log(`  ${chalk.cyan('timezone')}         Chuyển đổi múi giờ`);
    console.log(`  ${chalk.cyan('cron')}             Parse cron expressions`);
    console.log();
    console.log(chalk.bold('Khác:'));
    console.log(`  ${chalk.cyan('http')}             Gửi HTTP requests`);
    console.log(`  ${chalk.cyan('markdown-preview')} Xem trước file markdown`);
    console.log();
    console.log(chalk.bold('Chế độ Interactive:'));
    console.log(chalk.dim('  $ jai1 utils -i'));
    console.log(chalk.dim('  $ jai1 utils --interactive'));
    console.log();
    console.log(chalk.bold('Ví dụ:'));
    console.log(chalk.dim('  $ jai1 utils password --length 24'));
    console.log(chalk.dim('  $ jai1 utils uuid --count 5'));
    console.log(chalk.dim('  $ jai1 utils hash "text" --algorithm sha256'));
    console.log(chalk.dim('  $ jai1 utils http https://api.example.com'));
    console.log();
    console.log(chalk.dim('Chạy "jai1 utils <lệnh> --help" để xem chi tiết'));
}

/**
 * Create utils command group
 */
export function createUtilsCommand(): Command {
    const utilsCommand = new Command('utils')
        .description('Developer utilities for common tasks')
        .option('-i, --interactive', 'Run in interactive mode');

    // Add all subcommands
    utilsCommand.addCommand(createPasswordCommand());
    utilsCommand.addCommand(createUuidCommand());
    utilsCommand.addCommand(createHashCommand());
    utilsCommand.addCommand(createBase64EncodeCommand());
    utilsCommand.addCommand(createBase64DecodeCommand());
    utilsCommand.addCommand(createHttpCommand());
    utilsCommand.addCommand(createJwtCommand());
    utilsCommand.addCommand(createUnixTimeCommand());
    utilsCommand.addCommand(createTimezoneCommand());
    utilsCommand.addCommand(createUrlEncodeCommand());
    utilsCommand.addCommand(createUrlDecodeCommand());
    utilsCommand.addCommand(createCronCommand());
    utilsCommand.addCommand(createMarkdownPreviewCommand());

    // Default action - interactive mode if no subcommand, otherwise show help
    utilsCommand.action(async (options) => {
        if (options.interactive) {
            await runInteractiveMode();
        } else {
            showUtilsHelp();
        }
    });

    return utilsCommand;
}
